import { render, staticRenderFns } from "./TrendSkeleton.vue?vue&type=template&id=6374f32d"
import script from "./TrendSkeleton.vue?vue&type=script&lang=js"
export * from "./TrendSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TrendSkeleton.vue?vue&type=style&index=0&id=6374f32d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports